import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import { Form, message, Select, Switch, Button } from 'antd';
import {
  getContractInfoList,
  deletePriceContract,
  changeContractInfoStatus,
  getBudgetTypeEnum,
  getContractTypeEnum,
} from '@/services/goods.ts';
import RulesModal from "@/pages/baseProduct/components/RuleModal/RulesModal.tsx";
import { useSetState } from 'ahooks'
import ContentModal from './components/contentModal';
import DetailModal from './components/detailModal';
import { config } from './config/index.tsx';
import styles from './index.module.less';

export default function QuoteContract ()  {
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    type: 'goodsContractFilterRule',
  })
  const [contractFilterValue, setContractFilterValue] = useState('')
  const [contractPriceFilterValue, setContractPriceFilterValue] = useState('')

  const [editId, setEditId] = useState('');
  const listRef = useRef()

  const fetchList = async values => {
    try {
      const res: any = await getContractInfoList({
        ...values,
        pageId: values?.current,
        titleLike: values?.query?.title,
        quoteType: values?.query?.quoteType,
        contractType: values?.query?.contractType,
      });
      if (!res?.list) {
        message.error('查询列表失败');
        return;
      }
      return {
        records: res?.list,
        total: res?.count,
      };
    } catch (err) {
      message.error('查询列表失败');
    }
  }

  // 右侧表格事件：
  const onAdd = () => {
    setRuleModal({
      value: '',
    })
    setEditId('');
    setOpenPrintModal(true);
  }

  const onEdit = (record: any = {}) => {
    setRuleModal({
      value: '',
    })
    setEditId(record?.id);
    setOpenPrintModal(true);
  }

  const onDetail = (record: any = {}) => {
    setEditId(record?.id);
    setOpenDetailModal(true);
  };

  //   右侧下拉选项加载
  const getOptions = async () => {
    const contractRes: any = await getContractTypeEnum();
    const budgetRes: any = await getBudgetTypeEnum();
    return Promise.resolve({ budgetRes, contractRes })
  }

  const onDelete = async (record: any = {}) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deletePriceContract(record.id)
          if (res.errorCode === 0) {
            message.success('删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  }

  const changeStatus = async (enable: boolean, record: any) => {
    try {
      const res: any = await changeContractInfoStatus({
        id: record.id,
        enable,
      });
      if (res?.errorCode === 0) {
        message.success('修改状态成功');
        (listRef as any)?.current?.reload();
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleConfirmRule = ({ value }) => {
    if (ruleModal.type === 'goodsContractFilterRule') {
      setContractFilterValue(value);
    } else {
      setContractPriceFilterValue(value);
    }
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd },
    status: {
      // selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      // radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
    },
    customRender: {
      statusRender(value, record) {
        return (
          <div>
            <Switch checkedChildren="启用" unCheckedChildren="停用" checked={value} onChange={(enable) => changeStatus(enable, record)} />
          </div>
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onDetail(record)}>
              详情
            </SActionBtn>
            {
              !record?.enabled ? (
                <>
                  <SActionBtn onClick={() => onEdit(record)}>
                    编辑
                  </SActionBtn>
                  <SActionBtn style={{ color: 'red' }} onClick={() => onDelete(record)}>
                    删除
                  </SActionBtn>
                </>
              ) : null
            }
          </STableActions>
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        <SBack title="报价合同配置"></SBack>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      { openPrintModal && <ContentModal
        setRule={(value) => setRuleModal({...value})}
        contractFilterValue={contractFilterValue}
        contractPriceFilterValue={contractPriceFilterValue}
        setContractFilterValue={setContractFilterValue}
        setContractPriceFilterValue={setContractPriceFilterValue}
        list={listRef}
        editId={editId}
        open={openPrintModal}
        onClose={() => { setOpenPrintModal(false) }}
        />
      }
      { openDetailModal && <DetailModal editId={editId} open={openDetailModal} onClose={() => { setOpenDetailModal(false) }} /> }
      {/**TODO: ruleModal其实放在contentModal组件里会好点，复杂度更低 */}
      { ruleModal.open && <RulesModal
        modalProps={{...ruleModal, value: ruleModal.type === 'goodsContractFilterRule' ? contractFilterValue : contractPriceFilterValue}}
        onCancel={() => setRuleModal({open: false})}
        onOk={(value: string) => handleConfirmRule({value})}
        type={ruleModal.type}
      />}
    </div>
  )
}